import React from 'react';
import styled from 'styled-components';
import TextareaAutosize from 'react-textarea-autosize';

import Media from 'css/Media';

const TextArea = props => {
    return(
        <StyledLabel id={props.id} className={props.className}>
            <p>{props.label}</p>
            <TextareaAutosize
                name={props.name}
                inputRef={props.inputRef}
                minRows={props.minRows || 3}
                onChange={props.onChange}
            />
        </StyledLabel>
    )
}

export default TextArea;


const StyledLabel = styled.label`
    p { 
        ${props => props.theme.fonts.h6}
        ${Media.greaterThan('s')`
            padding: 0 0 ${props => props.theme.spacing.contentM} ${props => props.theme.spacing.contentM};
        `}
    }

    >p:first-of-type {
        color: ${props => props.theme.colors.inputText};
    }

    textarea {
        ~ p {
            color: ${props => props.theme.colors.danger};
            font-size: 14px;
            line-height: 16px;
            padding-top: ${props => props.theme.spacing.contentS};

            ${Media.greaterThan('s')`
                font-size: 16px;
            `}
        }
    }

    textarea {
        width: 100%;
        position: relative;
        height: ${props => props.theme.spacing.elementS};
        border: 1px solid ${props => props.validated ? props.theme.colors.input : props.theme.colors.input /* props.theme.colors.danger */};
        box-shadow: none;
        -webkit-appearance: none;
        border-radius: 0;
        ${props => props.theme.fonts.p}
        font-size: 14px;
        line-height: 20px;
        padding: 25px;
        background-color: ${props => props.theme.colors.negative};
        transition: border .2s ease;

        &:hover,
        &:focus-within {
            border-color: ${props => props.theme.colors.text};
        }

        ::-webkit-resizer {
            cursor: pointer;
            bottom: 0;
            right: 50%;
        }

        ${Media.greaterThan('s')`
            font-size: 16px;
            line-height: 28px;
        `}
    }
`
